module.exports = __webpack_public_path__ + "static/media/hospital.7ad7a1ce.svg";